import { InjectionToken, type Signal } from '@angular/core';
import type { Agent } from '../../../core/api/generated/models/Agent';
import type { AgentArchetype } from '../../../core/api/generated/models/AgentArchetype';
import type { AgentVersion } from '../../../core/api/generated/models/AgentVersion';

export type AgentDetailContext = {
  agent: Signal<Agent | null>;
  versions: Signal<AgentVersion[]>;
  archetypes: Signal<AgentArchetype[]>;
  archetype: Signal<AgentArchetype | null>;
  currentVersion: Signal<AgentVersion | null>;
  reload: () => void;
};

export const AGENT_DETAIL_CONTEXT = new InjectionToken<AgentDetailContext>('AGENT_DETAIL_CONTEXT');
